<template>
<nav aria-label="Page navigation">
    <div class="input-group mb-3">
    <div class="input-group-prepend">
        <button class="btn btn-outline-secondary" type="button" @click="previousPage"><span aria-hidden="true">&laquo;</span></button>
    </div>
    <select class="custom-select col-1" id="search-bar" @change="changePageNumber" v-model="pagination.pageSize" aria-label="Example select with button addon">
        <option selected>Number of Item</option>
        <option value="10" selected>10</option>
        <option value="50">50</option>
        <option value="100">100</option>
    </select>
    <div class="input-group-append">
        <button class="btn btn-outline-secondary" type="button" @click="nextPage"><span aria-hidden="true">&raquo;</span></button>
    </div>
    </div>
</nav>
</template>

<script>
export default {
    data() {
        return {
            pagination: {
                pageSize: 10,
                currentPage: 1
            }
        }
    },
    methods: {
        changePageNumber(evt) {
            this.pagination.pageSize = evt.target.value
            this.returnToParent()
        },
        previousPage() {
            if(this.pagination.currentPage !== 1) {
                this.pagination.currentPage -= 1
                this.returnToParent()
            }
        },
        nextPage() {
            this.pagination.currentPage += 1
            this.returnToParent()
        },
        returnToParent() {
            this.$emit('pageChanged', this.pagination)
        }
    }
}
</script>